import { actionTypes, change as reduxChange } from 'redux-form';
import moment from 'moment';
import { DATE_FORMAT } from '../constants';

import { fetchReservationData } from './actions';

import { translate } from '../withLocalize';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (
		action.type !== actionTypes.CHANGE ||
		!['arrival', 'departure'].includes(action.meta.field)
	) {
		return;
	}

	const state = store.getState();
	const formValues = state.form.bookingForm.values;
	const momentArrival = moment(formValues.arrival, DATE_FORMAT);
	const momentDeparture = moment(formValues.departure, DATE_FORMAT);

	const lengthOfStay = state.app.lengthOfStay;

	const t = (id, data = null) => translate(state.app.translations, state.app.lang, id, data);

	let arrival = null;
	let departure = null;
	let doFetch = true;

	if (action.meta.field === 'arrival') {
		if (momentArrival.isSameOrAfter(momentDeparture, 'day')) {
			departure = momentArrival.add(lengthOfStay[0] || 1, 'day').format(DATE_FORMAT);

		}  else if (lengthOfStay[0] !== null && momentDeparture.diff(momentArrival, 'days') < lengthOfStay[0]) {
			departure = momentArrival.add(lengthOfStay[0], 'days').format(DATE_FORMAT);
			window.alert(t('DepartureArrival.minLengthOfStay', { minLengthOfStay: lengthOfStay[0] }));

		}   else if (lengthOfStay[1] !== null && momentDeparture.diff(momentArrival, 'days') > lengthOfStay[1]) {
			departure = momentArrival.add(lengthOfStay[1], 'days').format(DATE_FORMAT);
			window.alert(t('DepartureArrival.maxLengthOfStay', { maxLengthOfStay: lengthOfStay[1] }));
		}

	} else if (action.meta.field === 'departure') {
		if (momentDeparture.isSameOrBefore(momentArrival, 'day')) {
			arrival = momentDeparture.subtract(lengthOfStay[0] || 1, 'day').format(DATE_FORMAT);

		}  else if (lengthOfStay[0] !== null && momentDeparture.diff(momentArrival, 'days') < lengthOfStay[0]) {
			arrival  = momentDeparture.subtract(lengthOfStay[0], 'days').format(DATE_FORMAT);
			window.alert(t('DepartureArrival.minLengthOfStay', { minLengthOfStay: lengthOfStay[0] }));

		}  else if (lengthOfStay[1] !== null && momentDeparture.diff(momentArrival, 'days') > lengthOfStay[1]) {
			arrival  = momentDeparture.subtract(lengthOfStay[1], 'days').format(DATE_FORMAT);
			window.alert(t('DepartureArrival.maxLengthOfStay', { maxLengthOfStay: lengthOfStay[1] }));
		}
	}

	if (departure) {
		doFetch = false;
		store.dispatch({...reduxChange('bookingForm', 'departure', departure), callback: action.callback });
	} else if (arrival) {
		doFetch = false;
		store.dispatch({...reduxChange('bookingForm', 'arrival', arrival), callback: action.callback });
	}

	if (doFetch) {
		store.dispatch(fetchReservationData(arrival || formValues.arrival, departure || formValues.departure))
			.then(() => {
				if (action.callback && typeof action.callback === 'function')
					action.callback();
			});
	}

};


// WEBPACK FOOTER //
// ./src/store/dateMiddleware.js